module.exports = __webpack_public_path__ + "ValvulaPlano4.png?d0054166649f2fb311a5daaf7a5eb32b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ValvulaPlano4.png
// module id = 2886
// module chunks = 0